module.exports = __webpack_public_path__ + "resources/img/img_tibero2_m.507cee8c58f0251c10cf1a2e2d778fd2.png";